import { createFileRoute } from '@tanstack/react-router'

import { DefaultLoader } from '#components/default-loader.tsx'
import { AutomationForm } from '#features/automations/automation-form.tsx'

export const Route = createFileRoute(
  '/_app/$workspace/_dashboard/automations/$id/edit',
)({
  head: () => ({ meta: [{ title: 'Edit Automation' }] }),
  component: RouteComponent,
  pendingComponent: DefaultLoader,
})

function RouteComponent() {
  const params = Route.useParams()
  return <AutomationForm mode="edit" automationId={params.id} />
}
